import type { OnboardingRequestDetail, OnboardingRequestListItem } from '../../onboarding/request.js';

export class OnboardingOperationsProvider {
  async list(identityToken: string): Promise<readonly OnboardingRequestListItem[]> {
    const value = await this.request('/api/onboarding/requests', identityToken);
    if (!Array.isArray(value)) throw new Error('Invalid onboarding response');
    return value as OnboardingRequestListItem[];
  }

  async detail(identityToken: string, requestNumber: string): Promise<OnboardingRequestDetail> {
    if (!/^ONB-[0-9]{6}$/.test(requestNumber)) throw new Error('Invalid request reference');
    const value = await this.request('/api/onboarding/requests/' + requestNumber, identityToken);
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
      throw new Error('Invalid onboarding response');
    }
    return value as OnboardingRequestDetail;
  }

  private async request(path: string, identityToken: string): Promise<unknown> {
    if (!identityToken) throw new Error('Authenticated session is unavailable');
    const response = await fetch(path, {
      headers: { Authorization: `Bearer ${identityToken}` },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('Onboarding request could not be loaded');
    return await response.json() as unknown;
  }
}
